// Explicit Client → Brand → Campaign selection (advanced/multi-client
// workspaces). Options are exactly what the API lists for the caller.
import { useBrands, useCampaigns, useClients } from "./queries";
import { Field } from "@/ui/field";
import { NativeSelect } from "@/ui/input";

export interface PickedContext {
  clientId?: string | undefined;
  brandId?: string | undefined;
  campaignId?: string | undefined;
}

export function ContextPicker({
  orgId,
  value,
  onChange,
  levels = 3,
  allowNewCampaign = false,
}: {
  orgId: string;
  value: PickedContext;
  onChange: (next: PickedContext) => void;
  levels?: 2 | 3;
  allowNewCampaign?: boolean;
}) {
  const clients = useClients(orgId);
  const brands = useBrands(orgId, value.clientId);
  const campaigns = useCampaigns(orgId, value.brandId);
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <Field label="Cliente">
        <NativeSelect
          value={value.clientId ?? ""}
          onChange={(e) => {
            onChange({ clientId: e.target.value || undefined });
          }}
        >
          <option value="">Selecciona…</option>
          {clients.items.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </NativeSelect>
      </Field>
      <Field label="Marca">
        <NativeSelect
          value={value.brandId ?? ""}
          disabled={!value.clientId}
          onChange={(e) => {
            onChange({ clientId: value.clientId, brandId: e.target.value || undefined });
          }}
        >
          <option value="">Selecciona…</option>
          {brands.items.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </NativeSelect>
      </Field>
      {levels === 3 ? (
        <Field label="Campaña">
          <NativeSelect
            value={value.campaignId ?? ""}
            disabled={!value.brandId}
            onChange={(e) => {
              onChange({ ...value, campaignId: e.target.value || undefined });
            }}
          >
            <option value="">{allowNewCampaign ? "Nueva campaña…" : "Selecciona…"}</option>
            {campaigns.items.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </NativeSelect>
        </Field>
      ) : null}
    </div>
  );
}
